import ImageTextBlockPreview from "./ImageTextBlockPreview";

export default ImageTextBlockPreview;